export default "__VITE_ASSET__e466c98d__"